import Text from "~/ui/typography"

export const NoSubscription = () => {
  return (
    <Text as="p" variant="body2">
      You are currently unsubscribed
    </Text>
  )
}
